export default __webpack_public_path__ + "static/media/main-banner.987c6827.png";